
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { HistoryItemType, HistoryPackageItem } from '@/features/shipment-history/types';
import LastScanItem from '@/features/shipment-history/components/tableColumns/LastScanItem.vue';

@Component({
  components: {
    LastScanItem,
  },
})
export default class LastScan extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  @Prop({ required: true }) visibleScans!: string[];

  @Prop({ required: true }) invisibleScans!: string[];

  @Prop({ required: true }) visiblePackages!: HistoryPackageItem[];

  @Prop({ required: true }) invisiblePackages!: HistoryPackageItem[];

  @Prop({ default: [] }) visibleStatuses!: string[];

  @Prop({ default: [] }) invisibleStatuses!: string[]

  @Prop({ required: true }) packagesExpanded!: boolean;

  private handleLastScanClick(packageItem: HistoryPackageItem): void {
    this.$emit('openDetails', 'tracking', packageItem.carrierTrackingNumber);
  }
}
